<ds-modal
  [modal]="modal"
  [title]="title"
  [maxWidthPercentage]="maxWidthPercentage"
  [closeAllModals]="closeAllModals"
  (modalClosed)="onCancel()"
>
  <ng-template ds-modal-header-actions>
    @if (!iconOnlyClose) {
      <button
        ds-button
        type="button"
        class="ds-action-confirmation-modal-close"
        data-test-id="ds-action-confirmation-modal-close"
        [variant]="DsButtonVariants.microActionHorizontalLayout"
        [microActionIcon]="Icons.XMark"
        (click)="onCancel()"
      >
        {{ closeLabel }}
      </button>
    }
  </ng-template>

  <p class="mb-0" data-test-id="ds-action-confirmation-modal-message">
    {{ message }}
  </p>
  @if (listItems | notNullishOrEmpty) {
    <ul class="mt-3 mb-0" data-test-id="ds-action-confirmation-modal-list">
      @for (item of listItems; track $index) {
        <li>{{ item }}</li>
      }
    </ul>
  }

  <ng-template ds-modal-slide-out-footer>
    <div class="d-flex flex-row justify-content-start gap-3 w-100">
      @if (keepButtonPrimary) {
        <button
          ds-button
          #keepButton
          type="button"
          data-test-id="ds-action-confirmation-modal-cancel"
          [variant]="DsButtonVariants.primary"
          (click)="onCancel()"
        >
          {{ cancelLabel }}
        </button>
        <button
          ds-button
          type="button"
          class="ds-action-confirmation-modal-cancel"
          data-test-id="ds-action-confirmation-modal-confirm"
          [variant]="DsButtonVariants.secondary"
          [intent]="DsButtonIntent.destructive"
          (click)="onConfirm()"
        >
          {{ confirmLabel }}
        </button>
      } @else {
        <button
          ds-button
          type="button"
          data-test-id="ds-action-confirmation-modal-confirm"
          [variant]="DsButtonVariants.primary"
          (click)="onConfirm()"
        >
          {{ confirmLabel }}
        </button>
        <button
          ds-button
          type="button"
          class="ds-action-confirmation-modal-cancel"
          data-test-id="ds-action-confirmation-modal-cancel"
          [variant]="DsButtonVariants.secondary"
          (click)="onSecondary()"
        >
          {{ cancelLabel }}
        </button>
      }
    </div>
  </ng-template>
</ds-modal>
